import { render, staticRenderFns } from "./AssessmentAndPlan.vue?vue&type=template&id=6f6c140e&"
import script from "./AssessmentAndPlan.vue?vue&type=script&lang=js&"
export * from "./AssessmentAndPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports